export const SERVICE_NAME = 'OROSY APPAREL';

export const COMPANY_NAME = 'orosy株式会社';

export const HOST_NAME = 'homula.jp';

export const UPLOADABLE_IMAGE_EXT = ['.png', '.jpg', '.jpeg'];
